React = require 'react'
{ PropTypes } = React
css = require '../../styles/Footer'

Footer = React.createClass
	displayName: 'Footer'
	propTypes:
		isLoggedIn: PropTypes.bool

	render: ->
		React.createElement("div", {"className": "container-fluid footer"},
			React.createElement("div", {"className": "footer-copyright"},
				React.createElement("p", null, "Copyright © ", ( new Date().getFullYear() ), ". All rights reserved.")
			)
		)

module.exports = Footer



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/components/Footer.cjsx